module.exports = __webpack_public_path__ + "img/txdz.2c5219bb.png";